import React from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Award, CheckCircle2, Circle, Download, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/dates";

const STEPS = ["Registered", "Attended live course", "Certified"];
const stepIndex = (a) => (a.certificate_id ? 2 : a.status === "attended" ? 1 : 0);

async function downloadCert(a) {
  try {
    const res = await api.get(`/certificates/${a.certificate_id}/download`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const link = document.createElement("a"); link.href = url; link.download = `Oral-Champion-${a.certificate?.cert_number || "certificate"}.pdf`; link.click();
    URL.revokeObjectURL(url);
  } catch { toast.error("Could not download the certificate"); }
}

function ChampionCard({ a }) {
  const idx = stepIndex(a);
  return (
    <div data-testid={`oc-champion-${a.id}`} className={`rounded-2xl border p-5 ${idx === 2 ? "border-rag-green/40 bg-rag-green-bg/40" : "border-cream-deep bg-cream-card"}`}>
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <div className="label-caps text-coral">{idx === 2 ? "Certified Oral Champion" : "Your Oral Champion"}</div>
          <div className="text-xl font-heading font-bold text-brand mt-1">{a.registrant_name}</div>
          <div className="text-sm text-muted-foreground">{a.job_title || "—"}{a.included && <span className="text-rag-green text-xs ml-2">(included place)</span>}</div>
          {a.session_date && <div className="text-sm text-muted-foreground mt-1 flex items-center gap-1.5"><Clock className="h-3.5 w-3.5" />{a.session_date}</div>}
        </div>
        {idx === 2 ? (
          <div className="text-right">
            <div className="text-xs text-muted-foreground">Certificate {a.certificate?.cert_number}</div>
            <div className="text-xs text-muted-foreground">Issued {fmtDate(a.certificate?.issued_at)} · 3 CPD hours</div>
            <Button size="sm" data-testid={`oc-cert-download-${a.id}`} onClick={() => downloadCert(a)} className="mt-2 rounded-full bg-brand hover:bg-brand-hover text-white"><Download className="h-4 w-4 mr-1.5" />Download certificate</Button>
          </div>
        ) : (
          <div className="text-xs text-muted-foreground max-w-[220px] text-right">The certificate is issued by KOHC once attendance at the live course is confirmed — you and your champion will both be emailed.</div>
        )}
      </div>
      <ol className="flex flex-wrap items-center gap-x-4 gap-y-2 mt-4 pt-4 border-t border-cream-deep/70 text-xs" data-testid={`oc-steps-${a.id}`}>
        {STEPS.map((s, i) => (
          <li key={s} className={`flex items-center gap-1.5 ${i <= idx ? "text-rag-green font-semibold" : "text-muted-foreground"}`}>
            {i <= idx ? <CheckCircle2 className="h-4 w-4" /> : <Circle className="h-4 w-4" />}{s}
          </li>
        ))}
      </ol>
    </div>
  );
}

export function ChampionStatus({ applications }) {
  if (!applications?.length) return null;
  return (
    <div className="space-y-3 mb-6" data-testid="oc-existing">
      <div className="flex items-center gap-2 text-brand font-heading font-bold"><Award className="h-5 w-5 text-coral" />Oral Champion status</div>
      {applications.map((a) => <ChampionCard key={a.id} a={a} />)}
    </div>
  );
}
